class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#SearchDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.drawer__inner').addEventListener('transitionend', this.onTransitionEnd.bind(this));
    this.bindSearchIcon();
  }

  bindSearchIcon() {
    const searchModal = document.querySelector('details-modal.header__search');
    if (!searchModal) return;

    this.searchModalSummary = searchModal.querySelector('summary');

    searchModal.addEventListener(
      'click',
      (event) => {
        if (window.innerWidth >= 990 || !this.searchModalSummary.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        this.classList.contains('active') ? this.close() : this.open(this.searchModalSummary);
      },
      { capture: true }
    );
  }

  onTransitionEnd(event) {
    if (event.target !== event.currentTarget || !this.classList.contains('active')) return;
    const input = this.querySelector('input[type="search"]');
    input.focus({ preventScroll: true });
    trapFocus(document.getElementById('SearchDrawer'), input);
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    const header = document.querySelector('.section-header');
    if (header) {
      const borderOffset = document.querySelector('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(header.getBoundingClientRect().bottom - borderOffset)}px`
      );
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active')) cartDrawer.close();

    const menuDrawer = document.querySelector('header-drawer');
    if (menuDrawer) {
      const mainDetails = menuDrawer.querySelector('details[open]');
      if (mainDetails) menuDrawer.querySelector('summary').click();
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch && predictiveSearch.close) predictiveSearch.close(true);
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('search-drawer', SearchDrawer);
